var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationWrapper',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('b-breadcrumb-item',{attrs:{"to":"/team"}},[_vm._v("Settings")]),_c('b-breadcrumb-item',{attrs:{"active":""}},[_vm._v("Invitations")])]},proxy:true}])},[_c('h1',{staticClass:"mb-3"},[_vm._v("Invitations")]),_c('b-row',[_c('b-col',[(Object.values(_vm.pendingInvitations).length !== 0)?_c('b-card',{key:"some",staticClass:"Card-table mb-3"},[_c('b-card-text',[_c('b-table',{attrs:{"responsive":"","small":"","fields":[
              {
                key: 'email',
                label: 'Email',
                sortable: true,
              },
              {
                key: 'created_by',
                label: 'Created By',
                formatter: function formatter(value, key, item) {
                  return ("" + (value.name || '@' + value.handle));
                },
                sortable: true,
              },
              {
                key: 'role.name',
                label: 'Role',
                sortable: true,
              } ],"items":_vm.pendingInvitations}})],1)],1):_c('b-card',{key:"none",staticClass:"text-center py-5 mb-3"},[_c('b-card-title',[_vm._v("No Pending Invitations Sent")]),_c('b-card-text',[_vm._v("\n          Use the form below to invite members to this team\n        ")])],1),_c('h3',{staticClass:"mb-3"},[_vm._v("Invite a Team Member")]),_c('b-card',[_c('b-row',[_c('InvitationForm',{attrs:{"callback":this.loadCallback}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }